// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"24c09a01","171":"c7adb407","432":"7fa7c157","994":"6423b7a3"}[chunkId] + ".chunk.js";
};